import { message } from 'antd';

import { postMedia } from './api';

export const createMediaWithFeedback = async (payload: any): Promise<boolean> => {
  try {
    await postMedia(payload);
    message.success('Successfully created media.');
    return true;
  } catch (error) {
    message.error('Error creating new media.');
    return false;
  }
};
